import React, {Component} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/app';
import 'firebase/database';
import FontAwesome from 'react-fontawesome';
import {EditorDialog} from '../editor-components';

/** @class CreateCategoryDialog
  * A component for creating a new exhibitor.
  * @prop {boolean} show - determines if the dialog should be visible
  * @prop {function} onExit - callback triggered when the dialog exit button is clicked
  */
export default class CreateCategoryDialog extends Component {
  /** @constructor
    * Constructs a new CreateCategoryDialog instance
    */
  constructor(props) {
    super(props);
    this.state = {
      name: ''
    }
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @function handleSave
    * Applies the current state to the database,
    * clears the form, and closes the dialog.
    */
  handleSave(event) {
    event.preventDefault();
    // Create exhibitor
    firebase.database().ref(`/affiliateCategories`).push({
      name: this.state.name
    })
    .then(()=>{
      this.setState({
        name: ''
      }, this.props.onExit);
    });
  }
  /** @method render
    * Renders the component
    */
  render() {
    const style={maxWidth: "80vw"}
    return (
      <EditorDialog show={this.props.show} onExit={this.props.onExit}>
        <h3>Add New Category</h3>
        <form onSubmit={this.handleSave} style={style}>
          <div className="input-group">
            <label htmlFor="name">Name</label>
            <input name="name" type="text"
              value={this.state.name}
              onChange={this.handleChange}
              required
              minLength={1}
              />
          </div>
          <div className="button-group">
            <button type="submit" className="btn btn-success">
              <FontAwesome name="save"/>
              Save Category
            </button>
          </div>
        </form>
      </EditorDialog>
    );
  }
}

CreateCategoryDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  onExit: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/affiliate-list/create-category-dialog.js